import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, renderList as _renderList, Fragment as _Fragment, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, normalizeStyle as _normalizeStyle, createVNode as _createVNode, resolveDirective as _resolveDirective, withDirectives as _withDirectives, createBlock as _createBlock } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "w100 mb10"
}
const _hoisted_2 = { key: 0 }
const _hoisted_3 = ["src"]
const _hoisted_4 = /*#__PURE__*/_createElementVNode("div", { class: "clear" }, null, -1)
const _hoisted_5 = {
  key: 1,
  class: "ScheduleHeaderTextContent posRe w100"
}
const _hoisted_6 = /*#__PURE__*/_createElementVNode("div", { class: "clear mb10" }, null, -1)
const _hoisted_7 = {
  key: 0,
  class: "mt40 qlContent"
}
const _hoisted_8 = ["innerHTML"]
const _hoisted_9 = /*#__PURE__*/_createElementVNode("div", { class: "clear" }, null, -1)
const _hoisted_10 = { key: 1 }
const _hoisted_11 = { key: 0 }
const _hoisted_12 = ["href", "onClick"]
const _hoisted_13 = { class: "fl" }
const _hoisted_14 = ["src"]
const _hoisted_15 = /*#__PURE__*/_createElementVNode("div", { class: "clear" }, null, -1)
const _hoisted_16 = { key: 1 }
const _hoisted_17 = ["href", "onClick"]
const _hoisted_18 = { key: 2 }
const _hoisted_19 = ["href", "onClick"]
const _hoisted_20 = { key: 3 }
const _hoisted_21 = ["href"]
const _hoisted_22 = {
  key: 4,
  class: "fw600 markdown",
  style: {"line-height":"1.3"}
}
const _hoisted_23 = /*#__PURE__*/_createElementVNode("div", { class: "orange fs12 fw600 text-center" }, [
  /*#__PURE__*/_createTextVNode("ダウンロード可能な"),
  /*#__PURE__*/_createElementVNode("br"),
  /*#__PURE__*/_createTextVNode("ファイルがあります")
], -1)
const _hoisted_24 = { class: "centered" }
const _hoisted_25 = {
  key: 0,
  class: "ddgrey fs12 fw600"
}
const _hoisted_26 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_27 = { class: "dgrey fs11" }
const _hoisted_28 = /*#__PURE__*/_createElementVNode("div", { class: "clear" }, null, -1)
const _hoisted_29 = /*#__PURE__*/_createElementVNode("div", { class: "clear" }, null, -1)
const _hoisted_30 = {
  key: 2,
  class: "",
  style: {"padding":"10px 30px","background":"#3c4b7c","color":"#fff"}
}
const _hoisted_31 = /*#__PURE__*/_createElementVNode("span", { class: "fs14" }, "公開期間", -1)
const _hoisted_32 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_33 = { class: "fs20 arial" }
const _hoisted_34 = /*#__PURE__*/_createElementVNode("div", { class: "clear" }, null, -1)
const _hoisted_35 = /*#__PURE__*/_createElementVNode("div", { class: "clear" }, null, -1)
const _hoisted_36 = {
  key: 3,
  class: "w100"
}
const _hoisted_37 = {
  class: "w100 llgreyBg fs11 dgrey",
  style: {"padding":"2px 16px"}
}
const _hoisted_38 = {
  class: "w100",
  style: {"padding":"10px 16px"}
}
const _hoisted_39 = {
  class: "fl",
  style: {"width":"calc(100% - 50px)"}
}
const _hoisted_40 = ["src"]
const _hoisted_41 = { class: "fl" }
const _hoisted_42 = { class: "fs12" }
const _hoisted_43 = { class: "fs22 arial fw600" }
const _hoisted_44 = { class: "ml3" }
const _hoisted_45 = /*#__PURE__*/_createElementVNode("div", { class: "clear" }, null, -1)
const _hoisted_46 = {
  key: 0,
  class: "fs16"
}
const _hoisted_47 = ["src"]
const _hoisted_48 = { key: 0 }
const _hoisted_49 = ["href"]
const _hoisted_50 = { key: 1 }
const _hoisted_51 = { class: "fs12" }
const _hoisted_52 = /*#__PURE__*/_createElementVNode("div", { class: "clear" }, null, -1)
const _hoisted_53 = {
  key: 0,
  class: "fr",
  style: {"height":"45px"}
}
const _hoisted_54 = /*#__PURE__*/_createElementVNode("div", { class: "clear" }, null, -1)
const _hoisted_55 = /*#__PURE__*/_createElementVNode("div", { class: "clear" }, null, -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_UserFileImage = _resolveComponent("UserFileImage")!
  const _component_UserIcon = _resolveComponent("UserIcon")!
  const _directive_tooltip = _resolveDirective("tooltip")!

  return (_ctx.room && (_ctx.hasImage || _ctx.hasContent || _ctx.hasTitle || _ctx.hasAttachment || _ctx.hasOpenPeriod))
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _createElementVNode("section", {
          class: _normalizeClass(`ScheduleCalendarContent with_white_bg ofs ${_ctx.rm.designType() == `normal` ? `` : `noShadow`}`),
          style: _normalizeStyle({
                padding: 0,
                minHeight: `auto`,
                transform: _ctx.rm.designType() == `normal` ? `auto` : _ctx.isSP ? `auto` : `translateX(-150px)`,
            })
        }, [
          (_ctx.hasImage)
            ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
                _createElementVNode("img", {
                  src: _ctx.$getAssetImageUrl(`${_ctx.room.appeal_content.image_url}`),
                  style: {"width":"100%"}
                }, null, 8, _hoisted_3)
              ]))
            : _createCommentVNode("", true),
          _hoisted_4,
          (_ctx.hasTitle || _ctx.hasContent)
            ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
                _createElementVNode("div", {
                  class: "fs15 kaigyo rad8 mt5",
                  style: _normalizeStyle({
                        padding: _ctx.hasContent
                            ? `${_ctx.isSP ? `20px 16px 10px` : `36px 30px`}`
                            : `${_ctx.isSP ? `20px 16px 5px` : `30px 36px 5px 36px`}`,
                    })
                }, [
                  _createElementVNode("div", {
                    class: _normalizeClass(_ctx.hasAttachment && !_ctx.isSP ? `w80 fl` : `w100`)
                  }, [
                    (_ctx.hasTitle)
                      ? (_openBlock(), _createElementBlock("span", {
                          key: 0,
                          class: _normalizeClass(`${_ctx.isSP ? `fs32` : `fs40`} fw900 mb20`)
                        }, _toDisplayString(_ctx.title), 3))
                      : _createCommentVNode("", true),
                    _hoisted_6,
                    (_ctx.hasContent)
                      ? (_openBlock(), _createElementBlock("div", {
                          key: 1,
                          class: _normalizeClass(`mt10 ${_ctx.isSP ? `mb20` : `mb10`}`)
                        }, [
                          (_ctx.room.appeal_content.content_type == `delta`)
                            ? (_openBlock(), _createElementBlock("div", _hoisted_7, [
                                _createElementVNode("div", { innerHTML: _ctx.deltaHtml }, null, 8, _hoisted_8),
                                _hoisted_9
                              ]))
                            : (_openBlock(), _createElementBlock("div", _hoisted_10, [
                                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.autoLink, (text, textindex) => {
                                  return (_openBlock(), _createElementBlock("span", {
                                    key: `${text}${textindex}`
                                  }, [
                                    (
                                            text.match(_ctx.TemplateUtil.buttonRegex) ||
                                            text.match(_ctx.TemplateUtil.buttonRegexWithOptions)
                                        )
                                      ? (_openBlock(), _createElementBlock("span", _hoisted_11, [
                                          _createElementVNode("button", {
                                            href: `${
                                                text.match(_ctx.TemplateUtil.buttonLinkRegex)[0].replace(`(`, ``).split(`)`)[0]
                                            }`,
                                            class: _normalizeClass(`w100 pad20 with_shadow hoverResetShadow with_white_bg innerLink fw600 text-left rad2 hoverGrey hoverLgreyBg ${
                                                _ctx.isSP ? `fs18` : `fs20`
                                            }`),
                                            rel: "noopener noreferrer",
                                            style: {},
                                            onClick: ($event: any) => (_ctx.clickButtonLink(text))
                                          }, [
                                            _createElementVNode("span", _hoisted_13, _toDisplayString(text.match(_ctx.TemplateUtil.buttonTextRegex)[0].replace(`[`, ``).replace(`]`, ``)), 1),
                                            _createElementVNode("img", {
                                              src: _ctx.$getAssetImageUrl(`/assets/icons/roundarrowS.png`),
                                              width: "25",
                                              height: "25",
                                              class: "fr mr7"
                                            }, null, 8, _hoisted_14),
                                            _hoisted_15
                                          ], 10, _hoisted_12)
                                        ]))
                                      : (text.match(_ctx.TemplateUtil.regex))
                                        ? (_openBlock(), _createElementBlock("span", _hoisted_16, [
                                            _createElementVNode("a", {
                                              href: text,
                                              class: _normalizeClass(`innerLink skyblue fw600 ${_ctx.isSP ? `fs12` : ``}`),
                                              target: "_blank",
                                              rel: "noopener noreferrer nofollow",
                                              style: {"text-decoration":"underline"},
                                              onClick: ($event: any) => (_ctx.clickInnerMessage(text))
                                            }, _toDisplayString(text), 11, _hoisted_17)
                                          ]))
                                        : (text.match(_ctx.TemplateUtil.mailRegex))
                                          ? (_openBlock(), _createElementBlock("span", _hoisted_18, [
                                              _createElementVNode("a", {
                                                href: `mailto:${text}`,
                                                class: _normalizeClass(`innerLink skyblue fw600 ${_ctx.isSP ? `fs12` : ``}`),
                                                target: "_blank",
                                                rel: "noopener noreferrer",
                                                style: {"text-decoration":"underline"},
                                                onClick: ($event: any) => (_ctx.clickMailto(text))
                                              }, _toDisplayString(text), 11, _hoisted_19)
                                            ]))
                                          : (
                                            text.match(_ctx.TemplateUtil.telRegex1) ||
                                            text.match(_ctx.TemplateUtil.telRegex2) ||
                                            text.match(_ctx.TemplateUtil.telRegex3)
                                        )
                                            ? (_openBlock(), _createElementBlock("span", _hoisted_20, [
                                                _createElementVNode("a", {
                                                  href: `tel:${text}`,
                                                  class: _normalizeClass(`innerLink skyblue fw600 ${_ctx.isSP ? `fs12` : ``}`),
                                                  target: "_blank",
                                                  rel: "noopener noreferrer",
                                                  style: {"text-decoration":"underline"}
                                                }, _toDisplayString(text), 11, _hoisted_21)
                                              ]))
                                            : (_openBlock(), _createElementBlock("span", _hoisted_22, _toDisplayString(text), 1))
                                  ]))
                                }), 128))
                              ]))
                        ], 2))
                      : _createCommentVNode("", true)
                  ], 2),
                  (_ctx.hasAttachment)
                    ? (_openBlock(), _createElementBlock("div", {
                        key: 0,
                        class: _normalizeClass(`${_ctx.isSP ? `w100` : `w20`} lorangeBg fr rad20 pad10`)
                      }, [
                        _hoisted_23,
                        _createVNode(_component_UserFileImage, {
                          file: _ctx.attachmentFile,
                          showDeleteButton: false,
                          type: `form`,
                          showOnlyIcon: true,
                          hideToolTip: false,
                          hideDownloadLink: true,
                          hideName: _ctx.isSP ? false : true,
                          class: _normalizeClass(`centered`),
                          parentId: _ctx.room.room_type == `parent_room` ? _ctx.room.id : null,
                          style: _normalizeStyle(`height: 60px; ${_ctx.isSP ? `` : ``}`)
                        }, null, 8, ["file", "hideName", "parentId", "style"]),
                        _createElementVNode("div", _hoisted_24, [
                          (_ctx.attachmentFile.original_filename)
                            ? _withDirectives((_openBlock(), _createElementBlock("span", _hoisted_25, [
                                _createTextVNode(_toDisplayString(_ctx.truncate(_ctx.attachmentFile.original_filename, 15, `...${_ctx.attachmentFile.extname}`)), 1)
                              ])), [
                                [_directive_tooltip, 
                                    _ctx.attachmentFile.original_filename.length > 15 ? `${_ctx.attachmentFile.original_filename}` : null
                                ]
                              ])
                            : _createCommentVNode("", true),
                          _hoisted_26,
                          _createElementVNode("span", _hoisted_27, _toDisplayString(_ctx.attachmentFile.file_size) + " " + _toDisplayString(_ctx.attachmentFile.extname.toUpperCase()), 1),
                          _hoisted_28,
                          _createElementVNode("div", {
                            class: "fw600 fs12 pointer orangeBg rad6 padw4 whiteColor",
                            onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.downloadFile(_ctx.attachmentFile))),
                            textContent: `ダウンロード`
                          })
                        ])
                      ], 2))
                    : _createCommentVNode("", true),
                  _hoisted_29
                ], 4)
              ]))
            : _createCommentVNode("", true),
          (_ctx.hasOpenPeriod)
            ? (_openBlock(), _createElementBlock("div", _hoisted_30, [
                _createElementVNode("div", {
                  class: _normalizeClass(["mt10", `${_ctx.isSP ? `fs12` : `fs14`} fw600`])
                }, [
                  _hoisted_31,
                  _hoisted_32,
                  _createElementVNode("p", _hoisted_33, _toDisplayString(_ctx.openPeriod), 1)
                ], 2),
                _hoisted_34
              ]))
            : _createCommentVNode("", true),
          _hoisted_35,
          (_ctx.isSP && !_ctx.isHideAppoInfo)
            ? (_openBlock(), _createElementBlock("section", _hoisted_36, [
                _createElementVNode("div", _hoisted_37, _toDisplayString(_ctx.$t(`schedule.schedule_information`)) + " ▼", 1),
                _createElementVNode("div", _hoisted_38, [
                  _createElementVNode("div", _hoisted_39, [
                    _createElementVNode("img", {
                      src: _ctx.$getAssetImageUrl(`/assets/icons/watch2.png`),
                      width: "16",
                      height: "16",
                      class: "fl mr7 mt5 ml1"
                    }, null, 8, _hoisted_40),
                    _createElementVNode("div", _hoisted_41, [
                      _createElementVNode("p", _hoisted_42, [
                        _createElementVNode("span", _hoisted_43, _toDisplayString(_ctx.room.current_appointment.duration), 1),
                        _createElementVNode("span", _hoisted_44, _toDisplayString(_ctx.$t(`schedule.min`)), 1)
                      ])
                    ]),
                    _hoisted_45,
                    (_ctx.room.current_appointment.location_name)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_46, [
                          _createElementVNode("img", {
                            src: _ctx.$getAssetImageUrl(`/assets/icons/mappin.png`),
                            width: "18",
                            height: "18",
                            class: "fl mr5"
                          }, null, 8, _hoisted_47),
                          (_ctx.Util.isUrl(_ctx.room.current_appointment.location_name))
                            ? (_openBlock(), _createElementBlock("div", _hoisted_48, [
                                _createElementVNode("a", {
                                  class: "fs12 skyblue",
                                  href: `${_ctx.room.current_appointment.location_name}`,
                                  target: "_blank"
                                }, [
                                  _createElementVNode("span", null, _toDisplayString(_ctx.room.current_appointment.location_name), 1)
                                ], 8, _hoisted_49)
                              ]))
                            : (_openBlock(), _createElementBlock("div", _hoisted_50, [
                                _createElementVNode("span", _hoisted_51, _toDisplayString(_ctx.room.current_appointment.location_name), 1)
                              ]))
                        ]))
                      : _createCommentVNode("", true),
                    _hoisted_52
                  ]),
                  (_ctx.room.owner)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_53, [
                        (_ctx.room.owner)
                          ? (_openBlock(), _createBlock(_component_UserIcon, {
                              key: 0,
                              width: 30,
                              canEdit: false,
                              member: _ctx.room.owner,
                              showTooltip: true,
                              class: "mr5 posRe"
                            }, null, 8, ["member"]))
                          : _createCommentVNode("", true),
                        _hoisted_54
                      ]))
                    : _createCommentVNode("", true),
                  _hoisted_55
                ])
              ]))
            : _createCommentVNode("", true)
        ], 6)
      ]))
    : _createCommentVNode("", true)
}